import type { ProjectId } from "@t3tools/contracts";

/**
 * A server-backed thread shell is authoritative once it is available. A loaded
 * thread detail covers a background thread whose shell has not reached this
 * renderer yet; draft sessions cover the short window before either exists.
 */
export const resolveHostedBrowserProjectId = (
  threadProjectId: ProjectId | null | undefined,
  draftProjectId: ProjectId | null | undefined,
  loadedThreadProjectId: ProjectId | null | undefined = null,
): ProjectId | null => threadProjectId ?? loadedThreadProjectId ?? draftProjectId ?? null;

/**
 * Samples the latest known navigation URL for a new profile guest. Existing
 * guests keep their own navigation state while the server reports updates.
 */
export const resolveHostedBrowserWebviewMountSource = (input: {
  readonly latestUrl: string | null;
  readonly fallbackUrl: string;
}): string => input.latestUrl ?? input.fallbackUrl;

export const resolveHostedBrowserWebviewSource = (input: {
  readonly generation: number;
  readonly mountUrl: string;
  readonly recoveryUrl: string;
}): string => (input.generation === 0 ? input.mountUrl : input.recoveryUrl);
